import { Edit } from "@/components/admin/edit";
import { SimpleForm } from "@/components/admin/simple-form";
import { ContractInputs } from "./ContractInputs";

export const ContractEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <SimpleForm className="max-w-4xl">
      <ContractInputs />
    </SimpleForm>
  </Edit>
);
